import { THeadingProps } from '../types/heading.types';
import { StringField, TLinkField } from '../../../../types/types';

export class HeadingModel {
  private readonly props: THeadingProps;
  private readonly isEE: boolean;

  constructor(props: THeadingProps, isEE: boolean) {
    this.props = props || null;
    this.isEE = isEE;
  }

  get title(): StringField {
    if (typeof this.props?.title === 'string') return { value: this.props.title } as StringField;
    return this.props?.title as StringField;
  }

  get eyebrow(): StringField {
    if (typeof this.props.eyebrow === 'string') return { value: this.props.eyebrow } as StringField;
    return this.props?.eyebrow as StringField;
  }

  get subtitle(): StringField {
    if (typeof this.props.subtitle === 'string') return { value: this.props.subtitle } as StringField;
    return this.props?.subtitle as StringField;
  }

  get link(): TLinkField | undefined {
    return this.props.link;
  }
  get isLinkExistsOrIsEE(): boolean {
    return !!(this.props.link?.value?.href || this.isEE);
  }

  get editable(): boolean {
    return !!this.props.editable;
  }

  get eyebrowExistsOrIsEE(): boolean {
    return !!(this.eyebrow?.value || this.isEE);
  }

  get titleExistsOrIsEE(): boolean {
    return !!(this.title?.value || this.isEE);
  }

  get subtitleExistsOrIsEE(): boolean {
    return !!(this.subtitle?.value || this.isEE);
  }
}
